import React, {Component} from "react";

class ModalHelp extends Component {
    render() {
        return (
            <div className="modal-help-wrapper">
                <button type="button" className="btn btn-secondary modal-help-btn" data-toggle="modal"
                        data-target="#modalHelp">
                    Help
                </button>
                <div className="modal fade" id="modalHelp" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Getting Started</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="help">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="panel panel-default">
                                                <div className="list-group">
                                                    <div className="list-group-item">
                                                        <h4 className="list-group-heading">Step 1</h4>
                                                        <div className="clear"/>
                                                        <p className="list-group-text">Login using your NUS IVLE
                                                            account</p>
                                                    </div>
                                                    <div className="list-group-item">
                                                        <h4 className="list-group-heading">Step 2</h4>
                                                        <div className="clear"/>
                                                        <p className="list-group-text">Watch a webcast/video from:</p>
                                                        <div className="clear"/>
                                                        <ul>
                                                            <li>Enrolled modules</li>
                                                            <li>Recent webcast/video you have watched</li>
                                                            <li>many other interesting modules</li>
                                                            <li>trending webcast/video</li>
                                                            <li>latest uploaded webcast/video</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <img src="/img/help.png" className="img-rounded img-help" alt="img-help"/>
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h3>Comment system</h3>
                                                </div>
                                                <div className="list-group">
                                                    <div className="list-group-item">
                                                        <h4 className="list-group-heading">Key Components</h4>
                                                        <div className="clear"/>
                                                        <ol>
                                                            <li>Show/Hide all comments</li>
                                                            <li>Adjust playback speed up to x3.0</li>
                                                            <li>Choose the settings for your comment</li>
                                                            <li>List of comments, sortable by clicking headers</li>
                                                            <li>Enter your comments here!</li>
                                                            <li>Hit 'Send' to confirm</li>
                                                            <li>The comments will appear on screen</li>
                                                        </ol>
                                                    </div>
                                                    <p>*You may have to pause the video to post a comment at the exact
                                                        time</p>
                                                    <p>*Visit <a target="_blank" href="/about">about page</a> to learn
                                                        more</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ModalHelp;


// WEBPACK FOOTER //
// ./src/componentsHeader/ModalHelp.js